import { BASE_URL } from '../../utils/constants';

export const allowedPaths = [`${BASE_URL}/signin`, `${BASE_URL}/signup`];

export const disallowedPaths = [
  `${BASE_URL}/reset-password`,
  `${BASE_URL}/signup/pin-verification`,
  `${BASE_URL}/forgot-password`,
  `${BASE_URL}/reset-password/*`,
  `${BASE_URL}/mobile-verification`,
  `${BASE_URL}/email-verification`,
  `${BASE_URL}/consent-permission`,
  `${BASE_URL}/user/profile`,
  `${BASE_URL}/feedback/*`,
  `${BASE_URL}/payee-list`,
  `${BASE_URL}/add-payee`,
  `${BASE_URL}/dashboard`,
  `${BASE_URL}/amaze`,
  `${BASE_URL}/amaze-acknowledge`,
  `${BASE_URL}/rfi`,
  `${BASE_URL}/ekyc-rfi`,
  `${BASE_URL}/kyc`,
  `${BASE_URL}/invite/*`,
  `${BASE_URL}/subscribe`,
  `${BASE_URL}/acknowledgement/*`,
  `${BASE_URL}/manage/payment-option`,
  `${BASE_URL}/referrals`,
  `${BASE_URL}/instapoints`,
  `${BASE_URL}/transaction-history`,
  `${BASE_URL}/transfer-money`,
  `${BASE_URL}/user/registration`,
  `${BASE_URL}/sgkyc/callback`,
  `${BASE_URL}/sgkyc/staging/callback`,
  `${BASE_URL}/my-info/registration`,
  `${BASE_URL}/batch-transaction`,
  `${BASE_URL}/post-logout`,
  `${BASE_URL}/nium-forex-send-money`,
  `${BASE_URL}/nium-forex/*`,
  `${BASE_URL}/migration-notice`,
  `${BASE_URL}/help-center`,
  `${BASE_URL}/high-value-transaction`,
  `${BASE_URL}/jumio/*`
];
